export var CRMUploadStatus;
(function (CRMUploadStatus) {
    CRMUploadStatus["Completed"] = "Completed";
    CRMUploadStatus["NotStarted"] = "Not Started";
    CRMUploadStatus["Started"] = "Started";
})(CRMUploadStatus || (CRMUploadStatus = {}));
;
[];
